import {IStation, IForecastValues, IForecast, IForecastType, IForecastResultManual, IForecastData} from '../../../api/api.types';
import {IStationApi} from '../../../api/station-api.service';
import IOrganizationApi from '../../../api/organization-api.service';
import {IImomoErrorService} from '../../../error/error.service';

export default class ForecastingTableController {
	private static readonly $inject = ['stationApi', 'organizationApi', '$window', 'imomoErrorService', '$mdDialog', '$translate'];

    private forecasts: IForecastData[];
    private station: IStation;
    private forecastType: IForecastType;
    private manualForecastValues: IForecastResultManual = {
        forecastTypeId: null,
        forecastedValue: null,
        previousValue: null,
        trainingDataCount: null,
        percentage: null,
        relativeError: null,
        standardDeviation: null,
        maximum: null,
        norm: null,
        minimum: null
    }
    private modelInvariantFields = ['previousValue', 'standardDeviation', 'maximum', 'norm', 'minimum'];
    private isWithAccepted: boolean = false;
    private isManualAccepted: boolean = false;
    
    constructor(
        private stationApi: IStationApi,
        private organizationApi: IOrganizationApi,
        private $window: ng.IWindowService,
        private imomoErrorService: IImomoErrorService,
        private $mdDialog: ng.material.IDialogService,
        private $translate:ng.translate.ITranslateService
    ) {
        const currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));
        this.manualForecastValues.forecastTypeId = this.forecastType.id;

        // if (this.forecastType.frequency !== 'seasonal') {
            this.forecasts.forEach((forecast: IForecastData) => { 
                if (forecast.forecastResults && forecast.forecastResults[0] && forecast.forecastResults[0].accepted) {
                    this.isWithAccepted = true;
                }
                let forecastResult = forecast.forecastResults[0];

                if (forecastResult) {
                    this.modelInvariantFields.forEach((field) => {
                        if ((<any>forecastResult)[field] || (<any>forecastResult)[field] === 0) {
                            (<any>this.manualForecastValues)[field] = (<any>forecastResult)[field];
                        }
                    });
                }
            });
        // } else {
        //     this.forecasts.forEach((forecast) => {
        //         if (forecast.forecastResults && forecast.forecastResults.length) {
        //             forecast.forecastResults.forEach((forecastResult) => {
        //                 if (forecastResult.accepted) {
        //                     this.isWithAccepted = true;
        //                 }
        //             });
        //         }
        //     });
        // }
    }

    onAcceptClick(forecastResult: IForecastValues) {

        let confirm = this.$mdDialog.confirm()
            .title('')
            .textContent(this.$translate.instant('NON_REVERTIBLE_ACTION'))
            .ok(this.$translate.instant('OK'))
            .cancel(this.$translate.instant('CANCEL'));

        this.$mdDialog.show(confirm).then(() => {
            this.stationApi.acceptForecast(this.station.id, forecastResult.id)
                .then(() => {
                    forecastResult.accepted = true;
                    this.isWithAccepted = true;
                })
                .catch((error) => {
                    this.imomoErrorService.showErrorDetailsDialog(error.data.details);
                })
        });
    }

    onManualAcceptClick() {
        this.stationApi.createManualForecast(this.station.id, this.manualForecastValues)
            .then(() => {
                this.isWithAccepted = true;
                this.isManualAccepted = true;
            })
            .catch((error) => {
                this.imomoErrorService.showErrorDetailsDialog(error.data.details);
            })
    }

    onTryRerunClick(stationId: number, forecast: number) {
    	
    }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/process/forecasting-table.controller.ts
 **/